// Map of record types to collections in the state
export default {
  auto_track: 'tracks',
  auto_track_run: 'tracks',
  auto_track_group: 'trackGroups',
}
